var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C6.48732 0 0 6.48732 0 14.5C0 22.5127 6.48732 29 14.5 29C22.5127 29 29 22.5127 29 14.5C29 6.48732 22.5126 0 14.5 0ZM14.5 27.2816C12.994 27.2816 11.3722 25.2736 10.3489 21.9527H18.6511C17.6278 25.2736 16.006 27.2816 14.5 27.2816ZM9.94343 20.4081C9.59591 18.8828 9.38351 17.1451 9.34491 15.2723H19.6552C19.6165 17.1644 19.3848 18.8828 19.0566 20.4081H9.94343ZM1.56392 15.2723H7.80029C7.8389 17.1065 8.05129 18.8442 8.37951 20.4081H2.99266C2.18174 18.8635 1.67974 17.1258 1.56392 15.2723ZM14.5 1.71835C16.006 1.71835 17.6278 3.72636 18.6511 7.04723H10.3489C11.3722 3.72636 12.994 1.71835 14.5 1.71835ZM19.0566 8.59184C19.4041 10.1172 19.6165 11.8548 19.6551 13.7276H9.34485C9.38346 11.8355 9.61515 10.1171 9.94337 8.59184H19.0566ZM7.80023 13.7277H1.56392C1.67974 11.8742 2.16244 10.1365 2.97335 8.5919H8.36015C8.05123 10.1558 7.8389 11.8935 7.80023 13.7277ZM21.1997 15.2723H27.4361C27.3203 17.1258 26.8376 18.8635 26.0266 20.4081H20.6399C20.9487 18.8442 21.1611 17.1065 21.1997 15.2723ZM21.1997 13.7277C21.1611 11.8935 20.9487 10.1558 20.6398 8.5919H26.0266C26.8375 10.1558 27.3202 11.8935 27.436 13.7277H21.1997ZM25.0806 7.04729H20.2537C19.6552 4.92345 18.8249 3.18575 17.8016 1.98871C20.7942 2.76096 23.3428 4.59518 25.0806 7.04729ZM11.1984 1.96935C10.1944 3.16644 9.34485 4.9234 8.74633 7.02793H3.91945C5.6571 4.59518 8.20572 2.76096 11.1984 1.96935ZM3.91945 21.9527H8.74633C9.34485 24.0765 10.1751 25.8143 11.1984 27.0113C8.20572 26.239 5.6571 24.4048 3.91945 21.9527ZM17.8016 27.0306C18.8056 25.8336 19.6551 24.0765 20.2536 21.972H25.0805C23.3428 24.4048 20.7942 26.239 17.8016 27.0306Z",
    fill: "#4B93FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 19.8706H28.3074V30.1735H15.8203V19.8706Z",
    fill: "#475F84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 19.4653H30.7912V20.2753H13.207V19.4653Z",
    fill: "#DBD8DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5469 29.4829H30.4513V30.8639H13.5469V29.4829Z",
    fill: "#DBD8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7539 30.5879H31.2436V32.0001H12.7539V30.5879Z",
    fill: "#EEEFEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 12L12.0234 19.4654H31.9775L22.0005 12Z",
    fill: "#EEEFEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3164 18.6406L21.9996 12.8608L29.6825 18.6406H14.3164Z",
    fill: "#DBD8DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 21.1362H17.0118V28.6528H14.625V21.1362Z",
    fill: "#DBD8DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2109 20.2754H17.4304V20.9866C17.4304 21.1563 17.2929 21.2939 17.1231 21.2939H14.5183C14.3485 21.2939 14.2109 21.1563 14.2109 20.9866V20.2754Z",
    fill: "#EEEFEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5151 28.4946H17.1192C17.2889 28.4946 17.4265 28.6322 17.4265 28.8019V29.4827H14.207V28.8022C14.2069 28.6325 14.3444 28.4948 14.5141 28.4946H14.5151Z",
    fill: "#E4E7E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8086 21.1362H23.1954V28.6528H20.8086V21.1362Z",
    fill: "#DBD8DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3906 20.2754H23.6101V20.9866C23.6101 21.1563 23.4725 21.2939 23.3028 21.2939H20.6982C20.5284 21.2939 20.3908 21.1563 20.3908 20.9866V20.2754H20.3906Z",
    fill: "#EEEFEE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6982 28.4946H23.3026C23.4723 28.4946 23.6099 28.6322 23.6099 28.8019V29.4827H20.3906V28.8022C20.3905 28.6325 20.528 28.4948 20.6977 28.4946H20.6982Z",
    fill: "#E4E7E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 21.1362H29.3751V28.6528H26.9883V21.1362Z",
    fill: "#DBD8DD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5742 20.2754H29.7937V20.9866C29.7937 21.1563 29.6561 21.2939 29.4864 21.2939H26.8815C26.7118 21.2939 26.5742 21.1563 26.5742 20.9866V20.2754Z",
    fill: "#EEEFEE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.882 28.4946H29.4864C29.6561 28.4946 29.7937 28.6322 29.7937 28.8019V29.4827H26.5742V28.8022C26.5741 28.6325 26.7115 28.4948 26.8813 28.4946H26.882Z",
    fill: "#E4E7E7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0078 15.2965C23.008 15.8524 22.5574 16.3032 22.0015 16.3033C22.0007 16.3033 21.9998 16.3033 21.999 16.3033C21.4437 16.3014 20.994 15.8517 20.9922 15.2965C20.9925 14.7403 21.4437 14.2897 21.9999 14.29C22.5436 14.2904 22.9889 14.7223 23.0058 15.2658C23.0079 15.2759 23.0086 15.2862 23.0078 15.2965Z",
    fill: "#475F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualBank);
export default __webpack_public_path__ + "static/media/virtual-bank.1e7b909daace354395490416ee3ee952.svg";
export { ForwardRef as ReactComponent };